import {
  type PlacementCandidate,
  PlacementCandidateScreeningStatus,
} from "@src/appV2/redesign/PlacementCandidate/types";

import { type PlacementWithDetails } from "../../../api/useFetchPaginatedPlacements";
import { ListHelper } from "./ListHelper";

interface TalkToRecruiterInterviewAvailabilityBulletProps {
  placement: PlacementWithDetails;
  placementCandidate: PlacementCandidate;
}

export function TalkToRecruiterInterviewAvailabilityBullet(
  props: TalkToRecruiterInterviewAvailabilityBulletProps
) {
  const { placement, placementCandidate } = props;
  const { isRecruiterScreeningEnabled } = placement;

  if (!isRecruiterScreeningEnabled) {
    return null;
  }

  return (
    <ListHelper.Item>
      <ListHelper.Text>
        {getActionTextForTalkToRecruiter(placementCandidate)}{" "}
        {getBookingTypeTextForTalkToRecruiter(placement)}
      </ListHelper.Text>
    </ListHelper.Item>
  );
}

function getActionTextForTalkToRecruiter(placementCandidate: PlacementCandidate) {
  const { screeningStatus } = placementCandidate;

  if (screeningStatus === PlacementCandidateScreeningStatus.FAILED) {
    return "Pass our Clipboard recruiter call to";
  }

  return "Talk to a Clipboard recruiter to";
}

function getBookingTypeTextForTalkToRecruiter(placement: PlacementWithDetails) {
  const { allowRequestInterview, interviewSettings } = placement;

  if (allowRequestInterview) {
    return "request an interview at this workplace!";
  }

  if (interviewSettings?.attributes.scheduleInterviews) {
    return "book an interview for this listing!";
  }

  return "instantly apply to this workplace!";
}
